import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./waitingApproval.module.scss";

const WaitingApproval = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();

  return (
    <Pill
      styleName="pending"
      Lefticon={<img src="../../../assets/images/svg/waiting_approval.svg" />}>
      <p className={classNames(styles.stockText, "p2")}>
        {t("lbl_waiting_payment_confirmation")}
      </p>
    </Pill>
  );
};

export default WaitingApproval;
